<template>
    <div id="app">
        <page-header :title="selectedGameName"></page-header>
        <div class="body-holder">
            <div class="content">
                <game :game="selectedGameComponentName" :showSp="showSp"></game>
            </div>
            <div class="sidebar">
                <sp-square v-if="showSp"></sp-square>
                <sp-vertical v-if="showSp"></sp-vertical>
            </div>
        </div>
        <page-footer></page-footer>
    </div>
</template>

<script>
import PageHeader from './components/PageHeader';
import PageFooter from './components/PageFooter';
import SpSquare from './components/SpSquare';
import SpVertical from './components/SpVertical';
import Game from './components/Game';

export default {
    data() {
        return {
            selectedGameName: 'Super Mario Bros.',
            selectedGameComponentName: 'SuperMario',
            showSpTimeout: null,
            showSp: true,
            pageCounter: 0,
        };
    },
    methods: {
        setShowSpTimeout() {
            this.showSpTimeout = setTimeout(() => {
                this.showSp = !this.showSp;
                this.setShowSpTimeout();
            }, (this.showSp ? 63 : 5) * 1000);
        },
    },
    mounted() {
        window.document.title = this.selectedGameName;
        this.setShowSpTimeout();
    },
    components: {
        PageHeader,
        PageFooter,
        SpSquare,
        SpVertical,
        Game,
    },
};
</script>

<style>
* {
    margin: 0;
    padding: 0;
}

body {
    background-color: #0a486c !important;
    color: #fff;
    font-family: verdana;
}

#app {
    width: 1366px;
    margin: 0 auto;
    background-color: #4a4a4a;
}

.body-holder {
    display: flex;
    flex-direction: row;
}

.content {
    width: 1010px;
    margin-top: 10px;
}

.sidebar {
    width: 356px;
    background-color: #fff;
}
</style>
